<template>
  <div class="admin-project-edit">
    <div class="page-header">
      <div class="header-left">
        <el-button icon="el-icon-arrow-left" size="small" @click="goBack">返回</el-button>
        <h2 class="page-title">{{ isEdit ? '编辑项目' : '新建项目' }}</h2>
      </div>
      <el-button type="primary" size="small" @click="saveProject">保存</el-button>
    </div>

    <el-card class="edit-card" shadow="never">
      <el-form :model="form" label-position="top" label-width="auto">
        <div class="section-title">基本信息</div>
        <el-row :gutter="24">
        <el-col :span="16">
          <el-form-item label="项目名称">
            <el-input v-model="form.name" placeholder="请输入项目名称" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="排序">
            <el-input-number v-model="form.sort_order" :min="0" controls-position="right" style="width:100%" />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="24">
        <el-col :span="24">
          <el-form-item label="项目链接">
            <el-input v-model="form.url" placeholder="https://..." />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="24">
        <el-col :span="24">
          <el-form-item label="项目描述">
            <el-input v-model="form.desc" type="textarea" :rows="3" placeholder="简短描述项目内容..." />
          </el-form-item>
        </el-col>
      </el-row>

      <div class="section-title">元信息</div>
      <el-row :gutter="24">
        <el-col :span="8">
          <el-form-item label="编程语言">
            <el-input v-model="form.lang" placeholder="Vue" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="语言颜色">
            <div class="color-picker-wrap">
              <el-color-picker v-model="form.lang_color" />
              <span class="color-value">{{ form.lang_color }}</span>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="更新日期">
            <el-input v-model="form.updated_date" placeholder="2026-07" />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="24">
        <el-col :span="12">
          <el-form-item label="Stars">
            <el-input-number v-model="form.stars" :min="0" controls-position="right" style="width:100%" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="Forks">
            <el-input-number v-model="form.forks" :min="0" controls-position="right" style="width:100%" />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="24">
        <el-col :span="24">
          <el-form-item label="标签（逗号分隔）">
            <el-input v-model="form.tags" placeholder="Flask, Vue2, MySQL" />
          </el-form-item>
        </el-col>
      </el-row>

      <div class="section-title">状态设置</div>
      <el-row :gutter="24">
        <el-col :span="6">
          <div class="switch-row">
            <span class="switch-label">是否私有</span>
            <el-switch v-model="form.is_private" />
            <span class="switch-hint">{{ form.is_private ? 'Private' : 'Public' }}</span>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="switch-row">
            <span class="switch-label">是否显示</span>
            <el-switch v-model="form.is_active" />
            <span class="switch-hint">{{ form.is_active ? '显示' : '隐藏' }}</span>
          </div>
        </el-col>
      </el-row>
      </el-form>
    </el-card>

    <div class="bottom-actions">
      <el-button @click="goBack">取消</el-button>
      <el-button type="primary" @click="saveProject">保存</el-button>
    </div>
  </div>
</template>

<script>
import { adminApi } from '../../utils/api'

export default {
  name: 'ProjectEdit',
  data() {
    return {
      isEdit: false,
      editId: null,
      form: this.getEmptyForm()
    }
  },
  created() {
    const id = this.$route.params.id
    if (id && id !== 'create') {
      this.isEdit = true
      this.editId = parseInt(id)
      this.loadProject()
    }
  },
  methods: {
    getEmptyForm() {
      return {
        name: '',
        desc: '',
        url: '',
        is_private: false,
        lang: '',
        lang_color: '#409EFF',
        stars: 0,
        forks: 0,
        updated_date: '',
        tags: '',
        sort_order: 0,
        is_active: true
      }
    },
    async loadProject() {
      try {
        const res = await adminApi.getProjects({ per_page: 1000 })
        const row = (res.projects || []).find(p => p.id === this.editId)
        if (!row) {
          this.$message.error('项目不存在')
          this.goBack()
          return
        }
        this.form = {
          name: row.name,
          desc: row.desc,
          url: row.url,
          is_private: row.is_private,
          lang: row.lang,
          lang_color: row.lang_color,
          stars: row.stars,
          forks: row.forks,
          updated_date: row.updated_date,
          tags: Array.isArray(row.tags) ? row.tags.join(', ') : (row.tags || ''),
          sort_order: row.sort_order,
          is_active: row.is_active
        }
      } catch (e) {
        console.error(e)
        this.$message.error('加载项目失败')
      }
    },
    async saveProject() {
      if (!this.form.name.trim()) {
        this.$message.error('请输入项目名称')
        return
      }
      try {
        if (this.isEdit) {
          await adminApi.updateProject(this.editId, this.form)
          this.$message.success('项目更新成功')
        } else {
          await adminApi.createProject(this.form)
          this.$message.success('项目创建成功')
        }
        this.goBack()
      } catch (e) {
        console.error(e)
        this.$message.error('保存失败')
      }
    },
    goBack() {
      this.$router.push('/admin/projects')
    }
  }
}
</script>

<style scoped>
.admin-project-edit {
  padding-bottom: 40px;
}
.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}
.header-left {
  display: flex;
  align-items: center;
  gap: 12px;
}
.page-title {
  font-size: 20px;
  font-weight: 600;
  color: var(--blog-text);
  margin: 0;
}
.edit-card {
  background: #fff;
  border-radius: 8px;
  margin-bottom: 20px;
}
.section-title {
  font-size: 15px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 18px;
  padding-bottom: 10px;
  border-bottom: 1px solid #ebeef5;
}
.section-title:not(:first-child) {
  margin-top: 30px;
}
.color-picker-wrap {
  display: flex;
  align-items: center;
  gap: 10px;
  height: 40px;
}
.color-value {
  font-size: 13px;
  color: #606266;
  font-family: monospace;
}
.switch-row {
  display: flex;
  align-items: center;
  gap: 12px;
  min-height: 40px;
  padding: 0 0 18px;
}
.switch-label {
  font-size: 14px;
  color: #606266;
}
.switch-hint {
  font-size: 13px;
  color: #909399;
}
.bottom-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}
</style>
